import React from 'react';
import { ITrusstorIconProps, TrusstorIconShared } from '@shared/components/TrusstorIconShared/TrusstorIconShared';

export const TrusstorIcon = React.memo((props: ITrusstorIconProps) => <TrusstorIconShared {...props} />);
